import React from 'react';

import styles from '../nuoV2.scss';
import { maxUtrpValue } from '../../../utils/constants';

const pickleballRatingsV2 = [
    {
        value: 'P1',
        label: 'Beginner',
    },
    {
        value: 'P2',
        label: 'Social/Casual',
    },
    {
        value: 'P3',
        label: 'Intermediate',
    },
    {
        value: 'P4',
        label: 'Advanced',
    },
    {
        value: 'P5',
        label: 'Expert/Pro',
    },
];

const PickleballScale = ({ value }) => {
    const pickleballRatingsMap = pickleballRatingsV2;

    return (
        <div className={`${styles.pkbrScale}`}>
            {pickleballRatingsMap.map((pkbRating, i) => (
                <div className={styles.segment} key={`segment-${pkbRating.value}`}>
                    <div className={styles.data}>
                        <div
                            className={`${styles.background}`}
                            style={{ opacity: (i + 1) / maxUtrpValue }}
                        />
                        <div className={styles.content}>
                            <div className={styles.selector}>
                                {value === pkbRating.value && (
                                    <img
                                        className={styles.indicator}
                                        src="/img/v2/icons/pkbr-scale-indicator.svg"
                                    />
                                )}
                            </div>
                            <div className={styles.scaleRating}>
                                {pkbRating.value}
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.label} ${styles.multiline} ellipsis`}>
                        {pkbRating.label}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PickleballScale;
